// extracted by mini-css-extract-plugin
export default {"container":"appbar2_container__iWekg"};